import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../api';
import { getPhases, getSeasonsByTeam } from '../api/seasons';
import Breadcrumb from '../components/Breadcrumb';
import { useCurrentTeam } from "../hooks/useCurrentTeam";
import 'font-awesome/css/font-awesome.min.css';
import "./CreateMatchDay.css";

function CreateMatchDay() {
    const [opponentName, setOpponentName] = useState('');
    const [date, setDate]                 = useState('');
    const [time, setTime]                 = useState('');
    const [location, setLocation]         = useState('');
    const [phase, setPhase]               = useState('');

    const [phases, setPhases]             = useState([]);
    const [currentSeasonId, setCurrentSeasonId] = useState(null);

    const [error, setError]               = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const navigate    = useNavigate();
    const { team }    = useCurrentTeam();

    useEffect(() => {
        const loadMeta = async () => {
            try {
                const [phaseData, seasonsData] = await Promise.all([
                    getPhases(),
                    team?.id ? getSeasonsByTeam(team.id) : Promise.resolve([]),
                ]);
                setPhases(phaseData || []);
                if (seasonsData?.length > 0) setCurrentSeasonId(seasonsData[0].id);
            } catch (err) {
                console.error('Error cargando fases', err);
            }
        };
        loadMeta();
    }, [team?.id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (!opponentName || !date || !time || !location) {
            setError('Por favor, completa todos los campos.');
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await apiClient.post('/matchdays', {
                teamId: team?.id,
                opponentName,
                date,
                location,
                time,
                seasonId: currentSeasonId || null,
                phase: phase || null,
            });

            const matchId = response.data?.id;

            if (matchId) {
                navigate(`/matchdays/${matchId}`);
            } else {
                navigate('/dashboard');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Error al crear el partido. Inténtalo de nuevo.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="match-create-wrapper">
            <Breadcrumb dark={false} crumbs={[
                { label: 'Inicio', to: '/dashboard' },
                { label: 'Nuevo Partido' },
            ]} />

            <div className="match-card">
                <div className="form-header">
                    <h1>Nuevo Partido</h1>
                    <p>Programa un encuentro contra otro equipo</p>
                </div>

                {error && (
                    <div className="error-banner">
                        <i className="fa fa-exclamation-circle"></i>
                        <span>{error}</span>
                    </div>
                )}

                <form onSubmit={handleSubmit} className="match-form">
                    <div className="form-group">
                        <label htmlFor="opponent">Equipo Rival</label>
                        <input
                            id="opponent"
                            type="text"
                            className="form-control"
                            value={opponentName}
                            onChange={(e) => setOpponentName(e.target.value)}
                            placeholder="Ej: Club de Tenis Barcino"
                            required
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="date">Fecha</label>
                            <input
                                id="date"
                                type="date"
                                className="form-control"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="time">Hora</label>
                            <input
                                id="time"
                                type="time"
                                className="form-control"
                                value={time}
                                onChange={(e) => setTime(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="location">Ubicación</label>
                        <input
                            id="location"
                            type="text"
                            className="form-control"
                            value={location}
                            onChange={(e) => setLocation(e.target.value)}
                            placeholder="Ej: Pista 3 - CEM Vall d'Hebron"
                            required
                        />
                    </div>

                    {phases.length > 0 && (
                        <div className="form-group">
                            <label htmlFor="phase">Fase</label>
                            <select
                                id="phase"
                                className="form-control"
                                value={phase}
                                onChange={(e) => setPhase(e.target.value)}
                            >
                                <option value="">Sin fase</option>
                                {phases.map(p => (
                                    <option key={p.value} value={p.value}>{p.label}</option>
                                ))}
                            </select>
                        </div>
                    )}

                    <button type="submit" className="btn-submit" disabled={isSubmitting}>
                        {isSubmitting ? (
                            <span><i className="fa fa-spinner fa-spin"></i> Creando...</span>
                        ) : (
                            <span><i className="fa fa-check"></i> Crear Partido</span>
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default CreateMatchDay;
